import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat, Tanggal } from '../../function/Format';

const ModalSuratSKGR = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: "",
		id_jenis: "",
		kk: "",
		agama: "",
		alamat: "",
		jenis_kelamin: "",
		kewarganegaraan: "Indonesia",
		nama_pemohon: "",
		nik: "",
		pekerjaan: "",
		pendidikan_terakhir: "",
		status_perkawinan: "",
		tanggal_lahir: new Date(),
		tempat_lahir: "",

		// pasangan
		alamat2: "",
		jenis_kelamin2: "",
		nama2: "",
		nik2: "",
		pekerjaan2: null,
		pendidikan_terakhir2: "",
		tanggal_lahir2: new Date(),
		tempat_lahir2: "",

		atas_nama: '',
		kuasa_atas: '',
		kuasa_untuk: '',
		lokasi_tanah: '',
		luas_tanah: '',
		no_reg: '',
		tanggal_skgr: new Date(),
		tujuan_kuasa: '',

		status_ttd: ''
	};

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmNik3: optionData.frmNik3,
		frmShdk: optionData.frmShdk,
		frmPkr: optionData.frmPkr,
		frmAgm: optionData.frmAgm,
		frmSpk: optionData.frmSpk,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk2: optionData.tmplistPenduduk2,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		// frmShdk: optionData.frmShdk,
		nikStat: null,
		nik2Stat: null,
		nik3Stat: null,
		// detail: [],
		status: {
			form: false,
			btnForm: false,
			dataPenduduk: optionData.status.dataPenduduk,
			dataPenduduk2: optionData.status.dataPenduduk2,
			dataPenduduk3: optionData.status.dataPenduduk3,
			btnAksi: [],
		},
		formPasangan: 'none',
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		console.log(data);
		console.log(optionData);

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			frmNik: optionData.frmNik,
			frmNik2: optionData.frmNik2,
			frmNik3: optionData.frmNik3,
			frmShdk: optionData.frmShdk,
			frmPkr: optionData.frmPkr,
			frmAgm: optionData.frmAgm,
			frmSpk: optionData.frmSpk,
			nikStat: optionData.nikStat,
			nik2Stat: optionData.nik2Stat,
			nik3Stat: optionData.nik3Stat,
			status: optionData.status,
			formPasangan: optionData.formPasangan,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false || e && fld == "nik2" || e && kioskMode == false && fld == "nik3") {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;
					case "nik2":
						setFormData({
							...formData,
							frmNik2: frmNik,
							tmplistPenduduk2: tmplistPenduduk,
							nik2Stat: nikStat
						})
						break;
					case "nik3":
						setFormData({
							...formData,
							frmNik3: frmNik,
							tmplistPenduduk3: tmplistPenduduk,
							nik3Stat: nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeSelectValue = (e, sel) => {
		setDt({
			...dt,
			[sel]: e,
		})
	}

	const dataPasangan = () => {
		let dataPenduduk2 = "block"

		let formPasangan = formData.formPasangan === "" ? "none" : "";

		if (formPasangan !== "") {
			dataPenduduk2 = "none"
		}

		setDt({
			...dt,
			alamat2: "",
			alamat_kk2: "",
			jenis_kelamin2: "",
			nama2: "",
			nik2: "",
			pekerjaan2: null,
			pendidikan_terakhir2: "",
			tanggal_lahir2: new Date(),
			tempat_lahir2: "",
		})
		setFormData({
			...formData,
			status: {
				...formData.status,
				dataPenduduk2
			},
			formPasangan,
			nik2Stat: null
		})
	}

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const gantiTgl = (date, fld) => {
		if (typeof date._isValid !== 'undefined') {
			let newVal = ''
			if (fld == "tanggal_lahir_anak") {
				newVal = new Date(date.format('YYYY-MM-DD HH:mm:ss'))
			} else {
				newVal = new Date(date.format('YYYY-MM-DD'))
			}
			setDt({
				...dt,
				[fld]: newVal
			})
		}
	}

	const getPenduduk = (e, jns) => {
		if (e) {
			
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }

            Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
                
                    if(data.results.data_kk){
                        alamat_kk = data.results.data_kk.alamat
                    }

                    if (jns === "nik") {
                        setDt({
                            ...dt,
                            agama: data.results.data_agama.nama,
                            alamat: alamat,
                            alamat_kk: alamat_kk,
                            jenis_kelamin: data.results.jk,
                            kk: data.results.id_kk,
                            nama_pemohon: data.results.nama,
                            nama: data.results.nama,
                            nik: data.results.id,
                            nik_pelapor: data.results.id,
                            pekerjaan: data.results.data_pekerjaan.nama,
                            pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                            status_perkawinan: data.results.status_perkawinan,
                            tanggal_lahir: data.results.tanggal_lahir,
                            tempat_lahir: data.results.tempat_lahir,
                        })

                        setFormData({
                            ...formData,
                            nikStat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk: "block"
                            },
                        })
                    } else if (jns === "nik2") {
                        setFormData({
                            ...formData,
                            nik2Stat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk2: "block",
                            },
                        })

                        setDt({
                            ...dt,
                            alamat2: alamat,
                            alamat_kk2: alamat_kk,
                            jenis_kelamin2: {
                                value: data.results.jk,
                                label: data.results.jk,
                            },
                            nama2: data.results.nama,
                            nik2: data.results.id,
                            pekerjaan2: {
                                value: data.results.data_pekerjaan.nama,
                                label: data.results.data_pekerjaan.nama,
                            },
                            pendidikan_terakhir2: data.results.data_pendidikan_terakhir.nama,
                            tanggal_lahir2: data.results.tanggal_lahir,
                            tempat_lahir2: data.results.tempat_lahir,
                        })
                    } else if (jns === "nik3") {
                        setFormData({
                            ...formData,
                            nik3Stat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk3: "block",
                            },
                        })
                        setDt({
                            ...dt,
                            agama_pelapor: data.results.data_agama.nama,
                            alamat_pelapor: alamat,
                            alamat_kk_pelapor: alamat_kk,
                            jenis_kelamin_pelapor: data.results.jk,
                            nama_pelapor: data.results.nama,
                            nik_pelapor: data.results.id,
                            pekerjaan_pelapor: data.results.data_pekerjaan.nama,
                            pendidikan_terakhir_pelapor: data.results.data_pendidikan_terakhir.nama,
                            status_perkawinan_pelapor: data.results.status_perkawinan,
                            tanggal_lahir_pelapor: data.results.tanggal_lahir,
                            tempat_lahir_pelapor: data.results.tempat_lahir,
                        })
                    }
                                  
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
            })
		} else {
			switch (jns) {
				case "nik":
					// setDt(frmDex)
					setDt({
						...dt,
						nik: '',
						kk: '',
						nama: '',
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						jenis_kelamin: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						alamat: '',
						alamat_kk: '',
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk: "none"
						},
						nikStat: null,
					})
					break;
				case "nik2":
					setDt({
						...dt,
						alamat2: "",
						alamat_kk2: "",
						jenis_kelamin2: "",
						nama2: "",
						nik2: "",
						pekerjaan2: null,
						pendidikan_terakhir2: "",
						tanggal_lahir2: new Date(),
						tempat_lahir2: "",
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk2: "none"
						},
						nik2Stat: null
					})
					break;
				case "nik3":
					setDt({
						...dt,
						nik_pelapor: '',
						nama_pelapor: '',
						agama_pelapor: '',
						tempat_lahir_pelapor: '',
						tanggal_lahir_pelapor: new Date(),
						jenis_kelamin_pelapor: '',
						pendidikan_terakhir_pelapor: '',
						status_perkawinan_pelapor: '',
						pekerjaan_pelapor: null,
						alamat_pelapor: '',
						alamat_kk_pelapor: '',
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk3: "none"
						},
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const simpan = (e) => {
		e.preventDefault();

        if (kioskMode){
            props.setLoadingPreview(true)
        }
        else{
            setAlert({
                loadingPreview: true
            })
        }
        
		let validasiPenduduk = false;
		let validasiPasangan = false;

		// validasi pemohon
		if (formData.nikStat != null) {
			validasiPenduduk = true;
		}

		// validasi pasangan
		// Input manual data pasangan
		if (formData.formPasangan !== "none") {
			if (dt.nik2 !== '' && dt.pekerjaan2 ) {
				validasiPasangan = true;
			}
		} else { // data pasangan otomatis
			if (formData.nik2Stat) {
				validasiPasangan = true;
			}
		}

		if (validasiPenduduk && validasiPasangan) {
			let tanggal_lahir = new Date(dt.tanggal_lahir);
			let tanggal_lahir2 = new Date(dt.tanggal_lahir2);
			let tanggal_skgr = new Date(dt.tanggal_skgr);

			let formDetail = [
                {
                    nama_item: "atas_nama",
                    isi_item: dt.atas_nama
                },
                {
                    nama_item: "no_reg",
                    isi_item: dt.no_reg
                },
                {
                    nama_item: "tanggal_skgr",
                    isi_item: dateFormat(dt.tanggal_skgr, 'yyyy-mm-dd')
                },
                {
                    nama_item: "luas_tanah",
                    isi_item: dt.luas_tanah
                },
                {
                    nama_item: "lokasi_tanah",
                    isi_item: dt.lokasi_tanah
                }
            ];

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(tanggal_lahir, 'yyyy-mm-dd'),
				tanggal_lahir2: dateFormat(tanggal_lahir2, 'yyyy-mm-dd'),
				pekerjaan2: dt.pekerjaan2.label,
				detail: formDetail
			};

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			Post(
				"surat-keterangan/kuasa/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)
        
					// Kalau mode kiosk
					if (kioskMode) {
						if (res.status === resstat) {
                            let dataAntrian = {
                              nama: props.data.results.nama,
                              nik: props.data.results.id,
                              keterangan: '',
                              uuid_surat:res.data.results.uuid_surat,
                              kode_surat:res.data.results.kode_surat,
                            };
                    
                            // Set Data Surat
                            props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
									
									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Kuasa SKGR', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Kuasa SKGR', 'gagal');
									}
								});
							}.bind(this),1000)
                        }
                        else{
							props.setLoadingPreview(false)
                            props.getAntrian('Surat Kuasa SKGR', 'gagal');
                        }
					} else { // Kalau bukan kiosk
						if (res.status === resstat) {
							const alertData = {
                                get_data_surat:{
                                  uuid_surat:res.data.results.uuid_surat,
                                  kode_surat:res.data.results.kode_surat,
                                },
                                status:{
                                  frmPreviewDraft: true,
                                  jenis_form: psn,
                                }
                                // show: true,
                                // basicType: "success",
                                // basicTitle: "Data Surat Kuasa SKGR",
                                // pesanAlert: "Berhasil " + psn + " Data",
                                // successAlert: true
							};
							setAlert({
								loadingPreview: false
							})
							setAlert(alertData);
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Kuasa SKGR",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
								loadingPreview: false
							})
							setAlert(alertData)
						}
						// Refresh list
						setStatusRefresh(true)
					}
				}
			);
		} else {
            if (kioskMode){
				props.getAntrian('Surat Kuasa SKGR', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}

	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: "60%", maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				style={{
					// maxHeight: "550px", overflowY: "scroll"
				}}
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Kuasa SKGR</h5>
					</div>
					<div className="modal-body">
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>

						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Pemohon</b>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								Kuasa Dari
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik");
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										name="nik"
										options={formData.frmNik}
										placeholder="Pilih NIK Pemberi Kuasa"
										onInputChange={e => handleInputChangeNIK(e, 'nik')}
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.dataPenduduk }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pemohon
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pemohon"
										type="text"
										placeholder="Nama Pemohon"
										value={dt.nama_pemohon}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tempat_lahir"
										type="text"
										placeholder="Tempat Lahir"
										value={dt.tempat_lahir}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										type="text"
										placeholder="Tanggal Lahir"
										value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat_kk"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_kk}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                    <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                </Col>
                            </FormGroup>
						</div>

						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Penerima Kuasa</b>
						</div>
						<FormGroup className="row mb-1">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik2"
							>
								Yang diberi kuasa
							</Label>
							<Col sm="9">
								{formData.formPasangan === "none" ? (
									<div data-testid="selectNIK2">
										<Select
											inputId="nik2"
											isDisabled={formData.status.select}
											classNamePrefix="select"
											onChange={e => {
												getPenduduk(e, "nik2");
											}}
											defaultValue={formData.nik2Stat}
											value={formData.nik2Stat}
											name="penduduk"
											onInputChange={e => handleInputChangeNIK(e, "nik2")}
											options={formData.frmNik2}
											placeholder="Pilih NIK Penerima Kuasa"
											isClearable
										/>
									</div>
								) : ''}
								<input
									data-testid="nik2"
									name="nik2"
									className="form-control"
									id="nik2"
									type={formData.formPasangan === "none" ? "hidden" : "text"}
									pattern="\d{1,16}"
									maxLength={16}
									minLength={16}
									required
									placeholder="Masukkan NIK Penerima (16 angka)"
									defaultValue={dt.nik2}
									value={dt.nik2}
									onChange={e => changeInputText(e, "nik2")}
								/>
								<small id="emailHelp" className="form-text text-muted">
									Data NIK {formData.formPasangan === "none" ? "tidak" : ""}{" "}
									tersedia?{" "}
									<span
										style={{ cursor: "pointer", color: "#0000ff" }}
										onClick={() => {
											if (formData.formPasangan === "none") {
												if (props.getJenisInput) {
													props.getJenisInput("manual")
												}
											}
											else {
												if (props.getJenisInput) {
													props.getJenisInput("auto")
												}
											}
											dataPasangan()
										}}
									>
										Klik disini
									</span>
								</small>
							</Col>
						</FormGroup>
						<div
							style={{ display: formData.status.dataPenduduk2 }}
						>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama 
								</Label>
								<Col sm="9">
									<input
										data-testid="nama2"
										name="nama2"
										className="form-control"
										id="nama2"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Contoh : Toni"
										defaultValue={dt.nama2}
										value={dt.nama2}
										onChange={e => changeInputText(e, "nama2")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir 
								</Label>
								<Col sm="9">
									<input
										data-testid="tempat_lahir2"
										name="tempat_lahir2"
										className="form-control"
										id="tempat_lahir2"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Contoh : Jakarta"
										defaultValue={dt.tempat_lahir2}
										value={dt.tempat_lahir2}
										onChange={e =>
											changeInputText(e, "tempat_lahir2")
										}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir 
								</Label>
								<Col sm="9">
									{
										formData.formPasangan === ""
											?
											<Datetime
												inputProps={{ "data-testid": "tanggal_lahir2", placeholder: 'Klik disini untuk memilih tanggal', required: true }}
												// data-testid="tanggal_lahir2"
												inputId="tanggal_lahir2"
												name="tanggal_lahir2"
												locale="id-ID"
												input={true}
												timeFormat={false}
												closeOnTab={true}
												closeOnSelect={true}
												dateFormat="DD/MM/yyyy"
												initialValue={dt.tanggal_lahir2}
												value={dt.tanggal_lahir2}
												onChange={(e) => {
													gantiTgl(e, 'tanggal_lahir2');
												}}
											/>
											:
											<input
												className="form-control"
												id="tanggal_lahir2"
												type="text"
												readOnly
												placeholder="Tanggal Lahir"
												value={dt.tanggal_lahir2}
												defaultValue={dt.tanggal_lahir2}
												style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
												disabled={formData.formPasangan === "" ? false : true}
											/>
									}

								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Pekerjaan 
								</Label>
								<Col sm="9">
									{formData.formPasangan === "" ? (
										<div data-testid="selectPekerjaan">
											<Select
												inputId="pekerjaan2"
												classNamePrefix="select"
												onChange={e => {
													changeSelectValue(e, "pekerjaan2");
												}}
												value={dt.pekerjaan2}
												name="pekerjaan2"
												options={formData.frmPkr}
												placeholder="Pilih Pekerjaan"
											// isClearable
											/>
										</div>
									) : (
										<input
											id="pekerjaan2"
											type="text"
											className="form-control"
											readOnly
											value={dt.pekerjaan2 ? dt.pekerjaan2.label : ''}
											style={{ backgroundColor: "#c9d1d8" }}
										/>
									)
									}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Alamat 
								</Label>
								<Col sm="9">
									<input
										data-testid="alamat_kk2"
										name="alamat_kk2"
										className="form-control"
										id="alamat_kk2"
										type="text"
										readOnly={formData.formPasangan === "" ? false : true}
										required
										placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
										defaultValue={dt.alamat_kk2}
										value={dt.alamat_kk2}
										onChange={e => changeInputText(e, "alamat_kk2")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
										data-testid="alamat2"
										name="alamat2"
										className="form-control"
										id="alamat2"
										type="text"
										readOnly={formData.formPasangan === "" ? false : true}
										required
										placeholder="Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau"
										defaultValue={dt.alamat2}
										value={dt.alamat2}
										onChange={e => changeInputText(e, "alamat2")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
                                    {
                                        formData.formPasangan === ""
                                        ?
                                            <small><font color="red">* Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau</font></small>
                                        :
                                            <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                    }
                                </Col>
                            </FormGroup>
						</div>
						
						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Tujuan</b>
						</div>

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Kuasa Untuk
							</Label>
							<Col sm="9">
								<input
									data-testid="kuasa untuk"
									name="kuasa_untuk"
									className="form-control"
									id="kuasa_untuk"
									type="text"
									// placeholder="kuasa untuk"
									defaultValue={dt.kuasa_untuk}
									value={dt.kuasa_untuk}
									onChange={e => changeInputText(e, "kuasa_untuk")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Kuasa Atas
							</Label>
							<Col sm="9">
								<input
									data-testid="kuasa atas"
									name="kuasa_atas"
									className="form-control"
									id="kuasa_atas"
									type="text"
									// placeholder="kuasa atas"
									defaultValue={dt.kuasa_atas}
									value={dt.kuasa_atas}
									onChange={e => changeInputText(e, "kuasa_atas")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tujuan Kuasa
							</Label>
							<Col sm="9">
								<input
									data-testid="tujuan kuasa"
									name="tujuan_kuasa"
									className="form-control"
									id="tujuan_kuasa"
									type="text"
									// placeholder="tujuan kuasa"
									defaultValue={dt.tujuan_kuasa}
									value={dt.tujuan_kuasa}
									onChange={e => changeInputText(e, "tujuan_kuasa")}
									required
								/>
							</Col>
						</FormGroup>

						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data SKGR</b>
						</div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Atas Nama
							</Label>
							<Col sm="9">
								<input
									data-testid="atas nama"
									name="atas_nama"
									className="form-control"
									id="atas_nama"
									type="text"
									placeholder="Contoh : Dedi Surya"
									defaultValue={dt.atas_nama}
									value={dt.atas_nama}
									onChange={e => changeInputText(e, "atas_nama")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								No. Reg
							</Label>
							<Col sm="9">
								<input
									data-testid="no reg"
									name="no_reg"
									className="form-control"
									id="no_reg"
									type="text"
									placeholder="Masukkan nomor registrasi"
									defaultValue={dt.no_reg}
									value={dt.no_reg}
									onChange={e => changeInputText(e, "no_reg")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tanggal
							</Label>
							<Col sm="9">
								<Datetime
									inputProps={{ "data-testid": "tanggal_skgr", "placeholder": "Klik untuk memilih tanggal", required: true }}
									inputId="tanggal_skgr"
									name="tanggal_skgr"
									locale="id-ID"
									input={true}
									closeOnTab={true}
									closeOnSelect={true}
									timeFormat={false}
									dateFormat="DD/MM/yyyy"
									initialValue={dt.tanggal_skgr}
									value={dt.tanggal_skgr}
									onChange={e => {
										gantiTgl(e, "tanggal_skgr");
									}}
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Lokasi Tanah
							</Label>
							<Col sm="9">
								<input
									data-testid="lokasi tanah"
									name="lokasi_tanah"
									className="form-control"
									id="lokasi_tanah"
									type="text"
									placeholder="Masukkan lokasi tanah"
									defaultValue={dt.lokasi_tanah}
									value={dt.lokasi_tanah}
									onChange={e => changeInputText(e, "lokasi_tanah")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Luas Tanah
							</Label>
							<Col sm="9">
								<input
									data-testid="luas tanah"
									name="luas_tanah"
									className="form-control"
									id="luas_tanah"
									type="text"
									placeholder="Contoh : 500 hektare"
									defaultValue={dt.luas_tanah}
									value={dt.luas_tanah}
									onChange={e => changeInputText(e, "luas_tanah")}
									required
								/>
							</Col>
						</FormGroup>

					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
						// disabled={formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratSKGR;